var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
const claim = namespace('claim');
const qualification = namespace('qualification');
let IsThirdPartyInvolvedQuestion = class IsThirdPartyInvolvedQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.yesNoQuestionValuesAndTradKeys = YES_OR_NO_CHOICES;
    }
    updateQualification(isThirdPartyInvolved) {
        this.updateAndSaveQualification({
            qualificationPayload: { isThirdPartyInvolved },
            step: this.step,
        });
    }
    get panelTitle() {
        return this.$tc('claim.qualification.electrical.is_third_party_involved.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.electrical.is_third_party_involved.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (this.qualification.isThirdPartyInvolved === null) {
            return null;
        }
        return this.qualification.isThirdPartyInvolved
            ? this.$tc('claim.qualification.electrical.is_third_party_involved.answer.yes')
            : this.$tc('claim.qualification.electrical.is_third_party_involved.answer.no');
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], IsThirdPartyInvolvedQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], IsThirdPartyInvolvedQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], IsThirdPartyInvolvedQuestion.prototype, "updateAndSaveQualification", void 0);
IsThirdPartyInvolvedQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], IsThirdPartyInvolvedQuestion);
export default IsThirdPartyInvolvedQuestion;
